import React, { useEffect } from "react";
import { getCommunityPrintOrders } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const PrintMaterialsCommunities = ({ getCommunityPrintOrders, communityPrintOrders, period }) => {
  useEffect(() => {
    getCommunityPrintOrders({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityPrintOrders(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityPrintOrders(payload);
  };

  return (
    <DataTable
      preset="printMaterialsCommunities"
      data={{
        docs: communityPrintOrders?.docs || [],
        totalPages: communityPrintOrders?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityPrintOrders: state.appCommunities.communityPrintOrders,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityPrintOrders: (payload) => dispatch(getCommunityPrintOrders(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintMaterialsCommunities);
